import core from './commuCore'
const output = {}
// 删除memo
function deleteMemo (data) {
  return core.ajax(data, 'internalMemo/deleteMemo', 'delete')
}
output.deleteMemo = deleteMemo

function getMemoByRelativeId (id) {
  return core.ajax(id, '/internalMemo/relativeId', 'get')
}
output.getMemoByRelativeId = getMemoByRelativeId

// 新增一个memo
function addInternalMemo (internalMemo) {
  return core.ajax(internalMemo, '/internalMemo', 'post')
}
output.addInternalMemo = addInternalMemo

function getMemoById (id) {
  return core.ajax(id, '/internalMemo', 'get')
}
output.getMemoById = getMemoById

function saveMemo (id) {
  return core.ajax(id, '/internalMemo', 'put')
}
output.saveMemo = saveMemo

function downloadAttac (path) {
  return core.ajax(path, '/internalMemo/download', 'post')
}
output.downloadAttac = downloadAttac

export default output
